import React from 'react';
import styled from 'styled-components';

/**
 * @param {Object} props
 * @param {React.CSSProperties} [props.bodyStyle] bodyStyle
 * @param {React.CSSProperties} [props.style] style
 * @returns
 */
export default function ShadowCard({ children, footer, bodyStyle, ...others }) {
  return (
    <Root {...others}>
      <Body style={bodyStyle} className='shadow-card-body'>
        {children}
      </Body>
      {footer && <Footer className='shadow-card-footer'>{footer}</Footer>}
    </Root>
  );
}

const Root = styled.div`
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #ffffff;
`;

const Body = styled.div`
  padding: 20px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  height: 60px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
